const moveDatePublished = () => {
	const breadcrumb = document.querySelector('.nav-tools') || null;
	const datePublished = document.querySelector('.actu-published') || null;
	if (breadcrumb && datePublished) {
		breadcrumb.insertAdjacentElement('afterbegin', datePublished);
	}
};

const init = () => {
	moveDatePublished();
};

init();
